import { apiService } from './api.service';
import {
  CloseShiftRequest,
  CreateShiftRequest,
  ShiftResponse,
} from './shift.service';

const BASE_PATH = 'shifts';

// Cashier-specific types (using base types directly for now)
export type CashierShiftRequest = CreateShiftRequest;
export type CashierCloseShiftRequest = CloseShiftRequest;
export type CashierShiftResponse = ShiftResponse;

/**
 * Open a new shift for the current cashier
 */
export const openCashierShift = async (
  data: CashierShiftRequest
): Promise<CashierShiftResponse> => {
  return apiService.getInstance().post(`${BASE_PATH}`, data);
};

/**
 * Close the current shift for a cashier
 */
export const closeCashierShift = async (
  shiftId: string,
  data: CashierCloseShiftRequest
): Promise<CashierShiftResponse> => {
  return apiService.getInstance().patch(`${BASE_PATH}/${shiftId}/close`, data);
};

/**
 * Get current active shift for a specific user (cashier)
 */
export const getCurrentCashierShift =
  async (): Promise<CashierShiftResponse | null> => {
    try {
      return apiService.getInstance().get(`${BASE_PATH}/current`);
    } catch (error: unknown) {
      if ((error as { status?: number })?.status === 404) {
        return null;
      }
      throw error;
    }
  };

/**
 * Get all active shifts (for managers/admins to see all cashier shifts)
 */
export const getAllActiveCashierShifts = async (): Promise<
  CashierShiftResponse[]
> => {
  return apiService.getInstance().get(`${BASE_PATH}/active`);
};
